module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"select_file":"选择文件","none":"无","file_add_failed":"文件增加失败"},"en":{"select_file":"Select File","none":"None","file_add_failed":"File addition failed"}}')
  delete Component.options._Ctor
}
